//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  curalate.component('loadingElement', {
    bindings: {
      height: '@?',
    },
    template: require('@legacy-components/common/loading-element/loading-element.html'),
  });
})();
